module.exports = __webpack_public_path__ + "img/FGr_Ortung_technisch.1012ce18.svg";